import { APIWorkspaceFile, WorkspaceFile } from '@/models/file';

export const extractFileID = (id: string): string => id.split('.')[0];

export const getWorkspaceFileURL = (id: string): string => `/library/${id}`;

export const parseWorkspaceFile = (file: APIWorkspaceFile): WorkspaceFile => ({
  id: file.file_id,
  slug: file.file_id.split('.')[0],
  name: file.file_name,
  date: new Date(file.timestamp_ms),
  size: file.file_size,
  orgID: file.organization_id,
  type: file.file_type,
  url: file.presigned_url,
  source: file.sharepoint_web_url ? 'sharepoint' : 'upload',
  sharepoint:
    file.sharepoint_web_url ||
    file.sharepoint_item_path ||
    file.sharepoint_last_modified
      ? {
          webUrl: file.sharepoint_web_url,
          itemPath: file.sharepoint_item_path,
          lastModified: file.sharepoint_last_modified,
        }
      : undefined,
});
